import React, { useEffect, useState } from "react";
import classes from './CCTVIntegrationsList.module.css'
import DataManager from "../../hooks/DataManager";
import ListCard from "../../components/GridList/ListCard";
import BasicTable from "../../components/Table/Table/Table";
import Pill_Widget from "../../components/UI/Widgets/Pill_Widget";
import { useDispatch, useSelector } from 'react-redux';
import Button1 from "../../components/UI/Button/Button1";
import { Await, Link, useNavigate } from "react-router-dom";
import { format } from 'date-fns';
import useSetCookie from "../../components/hooks/UseSetCookie";
import { serviceActions } from "../../store/service-Slice";
import SearchBar from "../SearchView/Search/SearchBar";
import { getGroups, setSiteActive } from "../../Api Methods/Api";
import hikLogo from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/hikLogoPortal.png'
import dahuaLogo from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/dahuaLogoPortal.png'
import ajaxLogo from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/ajaxLogoPortal.png'
import aiboxLogo from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/aiBoxLogoPortal.png'
import { id } from "date-fns/locale";
import Pill_Widget_2 from "../../components/UI/Widgets/Pill_Widget_2";
import { color } from "@mui/system";
import { InputSwitch } from "primereact/inputswitch";

const CCTVIntegrationsList = ({ sites, setSites }) => {

    console.log(sites)
    const [integrations, setIntegrations] = useState(sites);
    const token = useSelector(state => state.auth.token);
    const client = useSelector(state => state.auth.client);
    const apiData = {
        token,
        client
    }

    const dataManager = new DataManager();
    const [searchTerm, setSearchTerm] = useState("");
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const HandleUipiodOnClick = (DeviceUUID) => {
        console.log(DeviceUUID)
        if (DeviceUUID){
            dispatch(serviceActions.setDeviceUUID(DeviceUUID));
            navigate("/Dashboard/SiteView/" + DeviceUUID); 
        }
        useSetCookie("DeviceUUID", DeviceUUID, 1);
    }
    const [groups, setGroups] = useState([])

    useEffect(() => {
        const GetGroups = async () => {
            const groups = await getGroups(apiData, dispatch)
            setGroups(groups)
            console.log(groups)
        }

        GetGroups();
    }, [])

      const HandleSingleDeactivateSite = async (row) => {
        let body = {
          uuid: row.uuid,
          active: row.active == 1 ? 0 : 1
        };
    
        const response = await setSiteActive(apiData, body, dispatch);
        if (response.success){
          setSites((prevSites) =>
            prevSites.map((device) =>
                device.uuid === body.uuid ? { ...device, active: body.active } : device
            )
          );
        }
      }
    

    const HandleGroupOnClick = (groupName) => {
        const groupClicked = groups.find(g => g.name === groupName);
        if (groupClicked) {
            dataManager.setItem('groupClicked', groupClicked.name)   
            dataManager.setItem('groupPath', groupClicked.group_path)
            dataManager.setItem('groupClickedID', groupClicked.id)   
            navigate("/Dashboard/Groups/GroupSites")
        }
    }

    let tableColumns = [
        {
            id:"test",
            header: () => <div style={{ width: "20px" }}></div>,
            cell: (row) => {
                let logo = ""
                switch (row.row.original.integrationType){
                    case "HIKVISION": 
                        logo = hikLogo
                        break;
                    case "DAHUA":
                        logo = dahuaLogo
                        break;
                    case "AJAX": 
                        logo = ajaxLogo
                        break;
                    case "AIBOX":
                        logo = aiboxLogo
                        break;
                }
                return (
                    <div style={{width: "25px"}} onClick={() => HandleUipiodOnClick(row.row.original.uuid)}>
                        <img style={{width: "25px"}}src={logo}/>
                    </div>
                )
            }
        },
        {
            header: () => (
                <div className={classes.tableTitleText}>
                    <h3>Device</h3>
                </div> 
            ),
            accessorKey: 'integrationType',
            cell: (row) => {
                let text = ""
                let colour = ""
                let textColour = ""
                switch (row.row.original.integrationType){
                    case "HIKVISION": 
                        text = "Hikvision"
                        colour = "#616366"
                        break;
                    case "DAHUA":
                        text = "Dahua"
                        colour = "#ee0018"
                        break;
                    case "AJAX": 
                        text = "AJAX"
                        colour = "#1a1a1aff"
                        break;
                    case "AIBOX":
                        text = "AIBox"
                        colour = "#00bbf8"
                        break;
                }
                return (
                    <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
                        <Pill_Widget_2
                            pillColour={colour}
                            textColour={textColour}
                            text={text} 
                        />
                       
                    </div>
                )
            }
        },
        {
            header: () => (
                <div className={classes.tableTitleText}>
                    <h3>Identifier</h3>
                </div> 
            ),
            accessorKey: 'extraField1',
            cell: (row) => {
                return (
                    <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText2}>
                        {row.row.original.extraField1}
                    </div>
                )
            }
        },
        {
            header: () => (
                <div className={classes.tableTitleText}>
                    <h3>Portal name</h3>
                </div> 
            ),
            accessorKey: 'tag',
            cell: (row) => {
                return (
                    <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueTextBold}>
                        {row.row.original.tag && <Pill_Widget
                            boolean={true}
                            PillColor_IfTrue={"#919191"}
                            PillColor_IfFalse={"#6e6e6e"}
                            text_IfTrue={row.row.original.tag}
                            className={classes.PillHeight}
                        />}
                    </div>
                )
            }
        },
        {
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>App name</h3>
                </div> 
            ),
            accessorKey: 'deviceName',
            cell: (row) => {
                return (
                    <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
                        {row.row.original.deviceName && row.row.original.deviceName.trim() !== "" && (
                            <Pill_Widget
                                boolean={true}
                                PillColor_IfTrue={"#C3B1E1"}
                                PillColor_IfFalse={"#626a67"}
                                text_IfTrue={row.row.original.deviceName}
                                className={classes.PillHeight}
                            />
                        )}                
                    </div>
                )
            }
        },
        
        {
            header: () => (
                <div className={classes.tableTitleText}>
                    <h3>Site ID</h3>
                </div> 
            ),
            accessorKey: 'key',
            cell: (row) => {
                return (
                    <Link
                        to={`/Dashboard/SiteView/${row.row.original.uuid}`}
                        className={classes.tableValueText}
                    >
                        {row.row.original.key}
                    </Link>
                )
            }
        },
        {
            header: () => (
                <div className={classes.tableTitleText}>
                    <h3>Linked output</h3>
                </div>  
            ),
            accessorKey: 'pinName',
            cell: (row) => {
                return (
                    <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
                        {row.row.original.pinName}
                    </div>
                )
            }
        },
        {
            header: () => (
                <div className={classes.tableTitleText}>
                    <h3>Date linked</h3>
                </div> 
            ),
            accessorKey: 'created_at',
            cell: (row) => {
                const formattedDate =
                isNaN(new Date(row.row.original.created_at)) || 
                !row.row.original.created_at 
                  ? row.row.original.created_at 
                  : format(new Date(row.row.original.created_at), "MMMM do, yyyy - HH:mm");
                              return (
                    <div onClick={() => HandleUipiodOnClick(row.row.original.uuid)} className={classes.tableValueText}>
                        {formattedDate}
                    </div>
                )
            }
        },
        {
        header: () => (
            <div className={classes.tableTitleText} title="Click to sort">
                <h3>Site owned by</h3>
            </div> 
        ),
        accessorKey: 'name',
        cell: (row) => {
            let companyName = row.row.original.name;

            if (companyName == "RE:SURE") {
                companyName = "RESURE"
            }

            const companyColors = {
            EyeSpyFX: "rgb(100, 149, 237)",
            RESURE: "rgb(75, 0, 130)",
            PARFAS: "rgb(0, 0, 0)",
            PORTAL_SECURITY: "rgb(0, 0, 139)",
            SOLO: "rgb(178, 34, 34)",
            KNOWIO: "rgb(20, 155, 8)",
            CPS: "rgb(8, 155, 121)",
            CSC_SECURITY: "rgb(8, 150, 155)",
            EES: "rgb(94, 8, 155)"
            };

            const companyColor = companyColors[companyName] || "#6e6e6e";
            console.log(companyName)

            return (

                <div style={{
                    maxWidth: '100px',
                    overflow: 'hidden',
                    whiteSpace: 'normal',
                    display: '-webkit-box',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 2,
                    cursor: "pointer", color: "white", fontWeight: "600"
                }} onClick={() => HandleGroupOnClick(row.row.original.name)}>
                    <Pill_Widget
                    boolean={row.row.original.name !== null}
                    PillColor_IfTrue={companyColor}
                    PillColor_IfFalse={"#626a6700"}
                    text_IfTrue={row.row.original.name}
                    className={classes.PillHeight}
                    />
                </div>
            )
        }
        },
        {
            id: 'Active',
            header: () => (
                <div className={classes.tableTitleText}>
                <h3>Active site</h3>
                </div>
            ),
            filterLabel: "Active",
            accessorKey: 'active',
            cell: (row) => {
                const active = row.row.original.active == "1" ? true : false
                return (
                <div className={classes.tableValueText}>
                    <InputSwitch checked={active} onChange={() => HandleSingleDeactivateSite(row.row.original)}/>
                </div>
                )
            }
        },
    ]

    
    return (
        <div className={`${classes.table} ${classes.center} `}>
            <ListCard secondaryClassName={classes["Card-container"]}>
                <div className={classes["tableCardLayoutUI-wrapper"]} style={{ padding: "5px 10px 0px 10px" }}>
                    <Await resolve={sites}>
                        {(loadedtableData) => {
                            // State to store search input
                            // Function to filter data
                            const filteredData = loadedtableData.filter((item) =>
                                // Adjust this condition based on the properties you want to search
                                Object.values(item)
                                    .some(value => value?.toString().toLowerCase().includes(searchTerm.toLowerCase()))
                            );
    
                            return (
                                <>
                                   
                                    {/* Table */}
                                    <BasicTable
                                        data={filteredData}
                                        columns={tableColumns}
                                        filtering={""}
                                        rowClick={false}
                                        ShowPagination={false}
                                        PageSize={5000}
                                        paginationOptions={[25, 50, 100]}
                                        showFilterButton={false}
                                        isSortable={false}
                                    />
                                </>
                            );
                        }}
                    </Await>
                </div>
            </ListCard>
        </div>
    );
}

export default CCTVIntegrationsList;